import { IDocInfoExtendService } from '@src/slide/application/no-edit/service/doc-extend-service/doc-extend-service.interface';
import { DocInfoExtendEventsMap, DocInfoExtendEventsKeys } from '@src/slide/application/no-edit/service/doc-extend-service/doc-extend-service-events.interface';
import { EventEmitter as EventBus } from '@src/slide/infrastructure/module/independent/event-emitter';
import { SlideDataServices } from '@src/slide/domain/slide-app/core/slide-data-services.core';
import { IDocInfoManager } from '@src/slide/domain/slide-app/core/interfaces/doc-info.interface';
import { IEventEmitter } from '@src/slide/infrastructure/module/independent/event-emitter/event-emitter.interface';

/**
 * 获取文档&用户&权限等信息service
 * 基础内容在编辑区定义好，这里的扩展是给非编辑使用。
 */
export class DocExtendService implements IDocInfoExtendService {
    public event: IEventEmitter<DocInfoExtendEventsMap>;

    private mIsAuthExpired: boolean;
    private mUserInfo;

    public constructor() {
        this.event = new EventBus();
    }

    public get info() {
        return SlideDataServices.ClientVarsService()?.getClientVars() ?? {};
    }

    public get title(): string {
        return SlideDataServices.SlideTitleManager()?.title ?? '';
    }

    public get padId(): string {
        return this.docStore.padId ?? '';
    }

    public get globalPadId(): string {
        return this.docStore.globalPadId ?? '';
    }

    public get domainId(): string {
        return this.docStore.globalPadId ?? '';
    }

    public get creatorDomain(): string {
        return this.docStore.creatorDomain ?? '';
    }

    public get userId(): string {
        return this.docStore.userId ?? '';
    }

    public get isOwner(): boolean {
        return !!this.docStore.isOwner;
    }

    public get isCreator(): boolean {
        return !!this.docStore.isCreator;
    }

    public get padType(): string {
        return this.docStore.padType ?? '';
    }

    public get isDeleted(): boolean {
        return !!this.docStore.isDeleted;
    }

    public get tinyid(): string {
        return this.docStore?.tinyid ?? '';
    }

    public get userName(): string {
        return this.docStore?.userInfo?.userName ?? '';
    }

    public get userPic(): string {
        return this.docStore.userInfo?.userPic ?? '';
    }

    public get privilegeAttribute() {
        return SlideDataServices.PrivilegeManager()?.getPrivilegeAttribute() ?? {};
    }

    public get isAuthExpired(): boolean {
        return this.mIsAuthExpired;
    }

    public set isAuthExpired(val: boolean) {
        this.mIsAuthExpired = val;
    }

    public get policy(): number {
        return this.docStore?.policy ?? 0;
    }

    public get userInfo() {
        return this.mUserInfo;
    }

    public set userInfo(userInfo) {
        this.mUserInfo = userInfo;
    }

    /**
     * 注册文档&用户信息相关回调监听
     * @param eventName
     * @param listener
     */
    public addEventListener(eventName: DocInfoExtendEventsKeys, listener: (data: any) => void): () => void {
        return this.event.on(eventName, listener);
    }

    private get docStore(): IDocInfoManager {
        return SlideDataServices.DocInfoManager()!;
    }
}
